var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ElementRef, EventEmitter, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommunicationService } from '../../../services/communication.service';
import { HasSubscriptions } from '../../has-subscriptions';
import { MyRemaxModes } from '../../../classes/enums';
import { PreferencesService } from '../../../services/preferences.service';
var SearchResultsComponent = /** @class */ (function (_super) {
    __extends(SearchResultsComponent, _super);
    function SearchResultsComponent(__preferencesService, _communicationService, _router) {
        var _this = _super.call(this) || this;
        _this.__preferencesService = __preferencesService;
        _this._communicationService = _communicationService;
        _this._router = _router;
        _this.recentSearches = [];
        _this.searchInput = '';
        _this.isSearchingForResults = false;
        _this.showButtons = true;
        _this.locationResults = [];
        _this.listingResults = [];
        _this.mlsMatchResults = [];
        _this.onBlur = new EventEmitter();
        _this.selectResult = new EventEmitter();
        _this.favouriteClick = new EventEmitter();
        return _this;
    }
    SearchResultsComponent.prototype.ngOnInit = function () { };
    SearchResultsComponent.prototype.onCenterAtMyLocation = function () {
        this.__preferencesService.centerMapAtCurrentLocation(false, true);
        this._communicationService.toolbar.filtersRequested.next();
    };
    SearchResultsComponent.prototype.onSavedSearchesClick = function ($event) {
        this._router.navigate(['/my-remax'], { queryParams: { mode: MyRemaxModes.SAVED_SEARCHES } });
        this._communicationService.navigation.showSearch.next(false);
    };
    SearchResultsComponent.prototype.trackBy = function (index, elem) {
        return elem.id;
    };
    return SearchResultsComponent;
}(HasSubscriptions));
export { SearchResultsComponent };
